import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function HasGivenTransactionalConsent({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getState(query);
  const value = options.find((option) => option.value === state) ?? options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setState(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Has given transactional consent"
      description="Filter whether the application has given transactional consent"
      disabled={!editable}
    />
  );
}

const options = [
  { label: 'All', value: undefined },
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

function setState(value: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    CustomerTransactionalConsent: value,
  });
}

function getState(query: ace_index.FindInput) {
  return query.CustomerTransactionalConsent;
}

type Value = ace_index.FindInput['CustomerTransactionalConsent'];
